import React from 'react';

export interface FilterCollapsibleSectionProps {
  title: React.ReactNode;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  sectionId: string;
  compact?: boolean;
}

export default function FilterCollapsibleSection({
  title,
  open,
  onToggle,
  children,
  sectionId,
  compact = false,
}: FilterCollapsibleSectionProps) {
  const panelId = `${sectionId}-panel`;

  return (
    <section className={`sb-filter-section${compact ? ' sb-filter-section--compact' : ''}`}>
      <button
        type="button"
        className={`sb-filter-section__toggle${compact ? ' sb-filter-section__toggle--compact' : ''}`}
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className="sb-filter-section__title">{title}</span>
        <i
          className={`fas fa-chevron-down sb-filter-section__chevron${open ? ' sb-filter-section__chevron--open' : ''}`}
          aria-hidden
        />
      </button>
      <div
        id={panelId}
        className={`sb-filter-section__panel${open ? ' sb-filter-section__panel--open' : ''}`}
      >
        <div className="sb-filter-section__panel-inner">{children}</div>
      </div>
    </section>
  );
}
